import axiosBasicInstance from '../axiosConfig';

export const getRoleUrlByRoleName = async (roleName, langId) => {
   try {
      const response = await axiosBasicInstance.get(`/management/roleUrl/getListByRoleName/${roleName}`, {
         headers: {
            langId
         },
      });
      return response;
   } catch (error) {
      throw error;
   }
};
